<template>
  <div>
    <div class="p-3 card mb-3">
      <label class="titlePage">Seleção das Datas e Grupos de Aplicação</label>

      <fccTable
        striped
        hover
        responsive
        search
        pagination
        :disabled="disabled"
        :fields="fields"
        :items="items"
        :porPage="itemsPorPage"
        :key="componentKey"
        @row-selected="selecionaLinha"
      >
      </fccTable>

      <div class="text-right mb-3">
        <fccButton
          @click="adicionar"
          :disabled="dadosSelecionados.length <= 0 || abaDesabilitada"
          >{{ labelsSystem.adicionar }}</fccButton
        >
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import fccStore from '../../../../../store'
import { TP_SITUACAO } from '../../constantes'

export default {
  props: ['abaDesabilitada'],
  data() {
    return {
      itemsPorPage: 10,
      items: [],
      dadosSelecionados: [],
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: false
        },
        { key: 'dataaplic', label: 'Data de Aplicação', sortable: true },
        { key: 'grupo', label: 'Grupo', sortable: true },
        { key: 'provas', label: 'Provas', sortable: true }
      ],
      componentKey: 0
    }
  },
  created() {
    this.listarSelecaodasDasDatasEGruposDeAplicacao()
  },
  watch: {
    configuracao() {
      this.listarSelecaodasDasDatasEGruposDeAplicacao()
    }
  },
  computed: {
    configuracao() {
      return fccStore.state.localDeProva.configuracao
    },
    status() {
      return fccStore.state.localDeProva.listaStatus
    },
    disabled() {
      const status = this.status?.find((item) => item.tpEtapa === 1)
      return (
        status?.tpSituacao === TP_SITUACAO.FINALIZADO ||
        status?.tpSituacao === TP_SITUACAO.CANCELADO
      )
    }
  },
  methods: {
    forceRender() {
      this.componentKey += 1
    },
    selecionaLinha(dados) {
      this.dadosSelecionados = dados
    },
    adicionar() {
      const payload = this.dadosSelecionados.map((item) => {
        return {
          idLocalConfig: this.configuracao.idlocalconfig,
          idData: item.iddata,
          idPeriodo: item.idperiodo,
          idTurno: item.idturno,
          data: item.dataaplic,
          horaApres: item.horaapres,
          codGaplic: item.godgaplic,
          grupo: item.grupo,
          provas: item.provas,
          tempoProva: item.tempoprova,
          tempoPermanencia: item.tempominimopermanencia,
          cdFuncionario: this.dadosUserSession.usuCdFuncionario
        }
      })

      axios
        .post(
          fccStore.state.baseUrlLocalDeProva + 'DataGrupo/Inserir',
          payload,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.$emit('atualizar-lista')
          this.forceRender()
        })
        .catch(this.setErrorSystem)
    },
    listarSelecaodasDasDatasEGruposDeAplicacao() {
      axios
        .get(
          fccStore.state.baseUrlLocalDeProva +
            `LocalExameApresentacao/GetByDataGrupo/${this.configuracao.spi}/${this.configuracao.idfase}/${this.configuracao.idaplic}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.items = response.data
        })
        .catch(this.setErrorSystem)
    }
  }
}
</script>